import React, {useState, useEffect} from 'react'
import axios from 'axios';
import TasksReport from '../controls/TasksReport';
import LoadingControl from '../controls/Loading';

const TasksPane = (props) => {  
    
    const [state, setState] = useState({
        error: null,
        isLoaded: false,
        tasks: []
    });

    async function getData() {
      
        const res = await axios("/tasks");
        return res.data;
    }

    function update() {
        getData()
        .then(res => {
            setState({ error: null, isLoaded: true, tasks: res });
        })
        .catch(err => {
            setState( {error: err, isLoaded: false, tasks: [] });
        });
    }
    
    useEffect(() => {
        update();

        const interval = setInterval(() => update(), 30000);

        return () => {
            clearInterval(interval);
        };
    }, []);  
  
    if(state.error != null)
    {
        return (
            <div>
                <h3>{state.error.message}</h3>
            </div>
        );
    }
    else if (!state.isLoaded)
    {
        return (
            <div><LoadingControl/></div>
        );
    }
    else
    {
        return (
            <div>
                <TasksReport tasks = {state.tasks}/>
            </div>
        );   
    }   
}
  
export default TasksPane;